import React, {type PropsWithChildren} from 'react'
import styles from './UIGameChatContainer.module.scss'
import clsx from 'clsx'
import IconArrowUp from '@static/images/icon_arrow_up_black.svg'
import type {UIGameChatBackgroundColor} from '../UIGameChat.tsx'

export function UIGameChatContainer({
    children,
    isMinimized,
    setIsMinimized,
    minimizedTitle,
    showMinimizedNotification,
    backgroundColor,
}: PropsWithChildren<{
    isMinimized?: boolean
    setIsMinimized?: React.Dispatch<React.SetStateAction<boolean>>
    minimizedTitle?: string
    showMinimizedNotification?: boolean
    backgroundColor: UIGameChatBackgroundColor
}>) {
    const setIsMinimizedWrapper = (state: boolean) => {
        if(setIsMinimized) setIsMinimized(state)
    }

    if(isMinimized) {
        return (
            <div className={clsx(styles.container, styles[backgroundColor])}>
                <div className={styles.minimized} data-testid="chat-minimize-toggle" onClick={() => setIsMinimizedWrapper(false)}>
                    <div className={styles.minimizedTitle}>
                        {minimizedTitle}
                        {showMinimizedNotification === true && <span className={styles.minimizedRedDot} />}
                    </div>
                    <div className={styles.chatMinimizeButton}>
                        <img src={IconArrowUp} />
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className={clsx(styles.container, styles.maximized, styles[backgroundColor])}>
                {children}
            </div>
        )
    }
}
